module.exports = __webpack_public_path__ + "static/img/cooperation12.00e2da0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newImgs/cooperation12.png
// module id = I7ag
// module chunks = 11